'use client';

import { useLocalization } from '@/data/Localization';
import ReportGmailerrorredRoundedIcon from '@mui/icons-material/ReportGmailerrorredRounded';
import { Box, Link } from '@mui/material';
import { FC, useState } from 'react';
import { SelectDropdownDrawer } from '../parts/SelectDropdownDrawer';
type ReportProblemLinkProps = {
	sku: string;
	name?: string;
	departmentPDP?: string;
};
export const ReportProblemLink: FC<ReportProblemLinkProps> = ({ sku, name, departmentPDP }) => {
	const [open, setOpen] = useState(false);
	const { ReportProblem } = useLocalization('HDMProductDetail');

	const handleClick = () => {
		setOpen((prev) => !prev);
	};

	return (
		<>
			<Box sx={{ mt: 2, display: 'inline-flex', alignItems: 'center', gap: 1 }}>
				<ReportGmailerrorredRoundedIcon
					sx={{ color: 'secondary.main', width: '24px', height: '24px', mr: '5px' }}
				/>
				<Link
					component="button"
					onClick={handleClick}
					color="inherit"
					underline="hover"
					sx={{
						color: 'secondary.main',
						typography: 'bodyBaseline400',
					}}
					id="reportProblemLink"
				>
					{ReportProblem.t()}
				</Link>
			</Box>
			<SelectDropdownDrawer
				key={'selectComp'}
				open={open}
				closeEv={handleClick}
				skuNumber={sku}
				productTitle={name}
				departmentPDP={departmentPDP}
			/>
		</>
	);
};
